/*! @pentacode/ui v0.1.0 */
import { suggestionTopics as e } from "./data/assistant-suggestions.js";
import "./icon-DW8BBY5W.js";
import { t } from "./styledElement-DUAqv8gi.js";
import "./assistant-suggestion-pill-BBYedu2E.js";
import { t as n } from "./reduced-motion.css-tEHc8kYn.js";
import { t as r } from "./css-build-DcREbovZ.js";
import { activeIcon as i } from "./elements/icon/active-icon.js";
import { t as a } from "./decorateMetadata-BXz2gmG4.js";
import { t as o } from "./decorate-C_HUHFGG.js";
import { LitElement as s, html as c, nothing as l } from "lit";
import { customElement as u, property as d, state as f } from "lit/decorators.js";
// \0lit-plugin:css-sheet:./src/elements/assistant/assistant-suggestions/assistant-suggestions.css.js
var p = r(":host{height:max-content;transition:filter .3s, opacity .3s, transform .3s, overlay .3s allow-discrete, display .3s allow-discrete;transform-origin:100% 100%;flex-direction:column;align-items:end;gap:.5em;display:flex;position:relative}@starting-style{:host{filter:blur(10px);opacity:0;transform:scale(.9)translateY(50%)}}header{scrollbar-width:thin;scrollbar-color:var(--sky-blue) color-mix(in hsl, transparent 80%, var(--sky-blue));background:#fff;flex:none;width:100%;height:min-content;overflow:auto}.tabs{border-bottom:1px solid var(--shade-2);gap:.25rem;height:100%;display:flex}.tab-button{border-radius:var(--radius) var(--radius) 0 0;cursor:pointer;color:var(--color-text-secondary);white-space:nowrap;background:#fff;background:color-mix(in oklab, white 80%, var(--sky-blue));border:none;align-items:center;gap:.25rem;padding:.25rem .75rem;font-size:.7rem;transition:background-color .2s;display:flex}.tab-button:hover{background:var(--shade-1)}.tab-button.active{background:var(--sky-blue)}.suggestions-list{border-radius:var(--radius);scrollbar-width:thin;scrollbar-color:color-mix(in oklab, white 50%, var(--sky-blue)) transparent;flex-wrap:wrap;align-content:start;gap:.25rem;width:100%;height:100%;max-height:15rem;margin:0;padding:0;list-style:none;transition:all .3s;display:flex;overflow:auto}.suggestion{display:contents}.suggestion ptc-ui-assistant-suggestion-pill{opacity:0;height:min-content;translate:0 4rem;box-shadow:0 10px 40px -10px #0003}.suggestion:first-child ptc-ui-assistant-suggestion-pill{transition-delay:.1s}.suggestion:nth-child(2) ptc-ui-assistant-suggestion-pill{transition-delay:50ms}.toggle-topics{--pill-color:var(--neon);background:color-mix(in oklab, var(--neon) 50%, white)}.toggle-topics::part(icon){color:inherit}.toggle-topics ptc-ui-icon{font-size:.55rem}:host([expanded]){background:var(--color-bg-light);border-radius:var(--radius);cursor:pointer;color:var(--color-text-secondary);align-items:center;gap:.35rem;display:flex;overflow:hidden}:host([expanded]) .tabs{padding-bottom:0}:host([expanded]) .suggestions-list{padding:0 .5em .5em}:host([data-hidden]){opacity:0;filter:blur(10px);pointer-events:none}:host(:not([expanded])) .suggestions-list{flex-direction:column;align-items:end;overflow:visible}:host(:not([expanded])) .suggestion:nth-child(n+4){display:none}:host([bottom-aligned]){transform-origin:100% 0;flex-direction:column-reverse}:host([bottom-aligned]) .suggestions-list{flex-wrap:wrap-reverse}:host([left-aligned]){align-items:start}:host([left-aligned]) .suggestions-list{flex-wrap:wrap;align-items:start}:host([bottom-aligned]:not([expanded])) .suggestions-list{flex-direction:column-reverse}:host(:not([data-hidden])){filter:blur();pointer-events:none}:host(:not([data-hidden])) ptc-ui-assistant-suggestion-pill:first-child{opacity:1;translate:0}"), m = 3, h = class extends t(s) {
	constructor(...e) {
		super(...e), this.styles = [p, n], this.suggestions = [], this.recommendations = [], this.expanded = !1, this._activeTab = "recommended", this._suggestionsGroupedByTopic = /* @__PURE__ */ new Map(), this._availableTopics = [], this._collapsedSuggestions = [], this._handleSuggestionClick = (e) => () => {
			let t = e.prompt || e.title;
			this.dispatchEvent(new CustomEvent("suggestion-click", {
				detail: {
					prompt: t,
					suggestion: e
				},
				bubbles: !0,
				composed: !0
			}));
		};
	}
	_getAvailableTopics() {
		let t = /* @__PURE__ */ new Set();
		for (let e of this.suggestions) for (let n of e.topic) t.add(n);
		return Object.entries(e).filter(([e]) => t.has(e)).map(([e, t]) => ({
			key: e,
			config: t
		}));
	}
	_handleTabClick(e) {
		this._activeTab = e, this.dispatchEvent(new CustomEvent("topic-change", {
			detail: { topic: e },
			bubbles: !0,
			composed: !0
		}));
	}
	_handleExpandToggle() {
		this.expanded = !this.expanded, this._activeTab = "recommended", this.dispatchEvent(new CustomEvent("expand-toggle", {
			detail: { expanded: this.expanded },
			bubbles: !0,
			composed: !0
		}));
	}
	_renderSuggestionItem(t) {
		let n = t.topic[0], r = t.icon || (n ? e[n]?.icon : void 0) || "icon.object.info", i = n ? e[n] : void 0, a = t.color || i?.color || "var(--primary)";
		return c`
            <li class="suggestion">
                <ptc-ui-assistant-suggestion-pill
                    .icon=${r}
                    style="--pill-color: ${a}"
                    @click=${this._handleSuggestionClick(t)}
                >
                    ${t.title}
                </ptc-ui-assistant-suggestion-pill>
            </li>
        `;
	}
	_renderTabButton(t, n) {
		return c`
            <button
                class="tab-button ${this._activeTab === t ? "active" : ""}"
                @click=${() => this._handleTabClick(t)}
                style="--tab-color: ${n.color || "var(--primary)"}"
            >
                <ptc-ui-icon name=${i(e[t].icon, !0)}></ptc-ui-icon>
                ${n.label}
            </button>
        `;
	}
	_groupSuggestionsByTopic() {
		let e = /* @__PURE__ */ new Map();
		for (let t of this.suggestions) for (let n of t.topic) {
			let r = e.get(n);
			r || (r = /* @__PURE__ */ new Set(), e.set(n, r)), r.add(t);
		}
		return e;
	}
	_getSuggestionsForActiveTab() {
		return this._activeTab === "recommended" ? this.recommendations : Array.from(this._suggestionsGroupedByTopic.get(this._activeTab) ?? []);
	}
	_pickCollapsedSuggestions() {
		return [...this._getSuggestionsForActiveTab()].sort(() => Math.random() - .5).slice(0, m).sort((e, t) => t.title.length - e.title.length);
	}
	_getDisplayedSuggestions() {
		return this.expanded ? this._getSuggestionsForActiveTab() : this._collapsedSuggestions;
	}
	willUpdate(e) {
		e.has("suggestions") && (this._suggestionsGroupedByTopic = this._groupSuggestionsByTopic(), this._availableTopics = this._getAvailableTopics()), (e.has("suggestions") || e.has("recommendations") || e.has("_activeTab")) && (this._collapsedSuggestions = this._pickCollapsedSuggestions());
	}
	render() {
		return this.suggestions.length === 0 ? c`<div>Keine Vorschläge verfügbar</div>` : c`
            <header ?hidden=${!this.expanded}>
                <div class="tabs">
                    <button
                        class="tab-button ${this._activeTab === "recommended" ? "active" : ""}"
                        @click=${() => this._handleTabClick("recommended")}
                    >
                        <ptc-ui-icon name="icon.object.suggestion:active"></ptc-ui-icon>
                        Empfohlen
                    </button>

                    ${this._availableTopics.map(({ key: e, config: t }) => this._renderTabButton(e, t))}
                </div>
            </header>

            <ul class="suggestions-list">
                ${this._getDisplayedSuggestions().map((e) => this._renderSuggestionItem(e))}
            </ul>

            ${this.expanded ? l : c`<ptc-ui-assistant-suggestion-pill
                      class="toggle-topics"
                      @click=${this._handleExpandToggle}
                      title="Alle anzeigen"
                      icon="icon.action.show-all"
                  >
                      Alle anzeigen
                  </ptc-ui-assistant-suggestion-pill>`}
        `;
	}
};
o([d({
	type: Array,
	reflect: !1
}), a("design:type", Array)], h.prototype, "suggestions", void 0), o([d({
	type: Array,
	reflect: !1
}), a("design:type", Array)], h.prototype, "recommendations", void 0), o([d({
	type: Boolean,
	reflect: !0
}), a("design:type", Object)], h.prototype, "expanded", void 0), o([f(), a("design:type", Object)], h.prototype, "_activeTab", void 0), h = o([u("ptc-ui-assistant-suggestions")], h);
export { h as t };

//# sourceMappingURL=assistant-suggestions-4XupKMF3.js.map